import {css, Icon, view} from '@sail/ui/deprecated';
import type {IconAsset} from '@sail/icons/types';

export const ChannelIcon = ({icon}: {icon: IconAsset}): JSX.Element => {
  return (
    <view.div
      data-testid="channel-icon"
      className="channel-icon"
      css={{
        borderRadius: 'rounded',
        width: 500,
        height: 500,
        backgroundColor: css.value('$color.neutral50'),
        display: css.value('flex'),
        alignItems: css.value('center'),
        justifyContent: css.value('center'),
      }}
    >
      <Icon icon={icon} size="small" />
    </view.div>
  );
};
